export default __webpack_public_path__ + "static/media/Drakumba60s.947df946.mp3";